export const portfolioData = {
  about: {
    title: "À propos de moi",
    description: "Administrateur système & réseau passionné...",
    skills: ["Linux", "Windows", "Virtualisation"]
  },
  projects: [
    {
      id: 1,
      title: "Boost-Heberg",
      year: "2020",
      description: "Hébergeur de serveur de jeux via Pterodactyl ainsi que de VPS via Proxmox",
      technologies: ["Projet Perso", "Linux", "Virtualisation"],
      link : "https://docs.julieng6v.fr/"
    },
    {
      id: 2,
      title: "UPServ",
      year: "2025",
      description: "Hébergeur de VPS, VDS et de serveurs dédiés, spécialisé dans la mise en place de protections réseau renforcées contre les attaques DDoS.",
      technologies: ["Projet Perso", "Linux", "Entreprise"],
      link : "#"
    },
    {
      id: 3,
      title: "StreamBox",
      year: "2025",
      description: "Service de streaming privé permettant d’accéder aux chaînes de télévision et aux catalogues pour regarder des films et des séries.",
      technologies: ["Projet Pero", "Linux", "Réseau"],
      link : "#"
    },
    {
      id: 4,
      title: "Grafana",
      year: "2025",
      description: "IInstallation d’un système de supervision basé sur Grafana, permettant de surveiller l’état du réseau ainsi que mes serveurs personnels et professionnels.",
      technologies: ["Projet personnel", "Linux", "Réseau"],
      link : "#"
    },
    {
      id: 5,
      title: "Projet BMS",
      year: "2024",
      description: "Configuration complète à faire du pare-feu, serveurs Windows et Debian à l'aide d'un cahier des charges, configuration d'un Pfsense, ",
      technologies: ["Projet Scolaire", "Windows", "Réseau"],
      link : "https://docs.julieng6v.fr/books/projet-bms"
    },
    {
      id: 6,
      title: "Projet MDL",
      year: "2025",
      description: "Configuration complète à faire du pare-feu, serveurs Windows et Debian à l'aide d'un cahier des charges, création d'un redondance de Pfsense et mise en place de sauvegarde via CobianReflector, installation & configuration d'OpenVPN sur le routeur",
      technologies: ["Projet Scolaire", "Windows", "Réseau"],
      link : "https://docs.julieng6v.fr/books/projet-mdl"
    },
    {
      id: 7,
      title: "Veille Technologique",
      year: "2024",
      description: "Plateforme de veille technologique permettant de suivre les dernières actualités et innovations dans le domaine des infrastructures réseaux, de la cybersécurité, de l'administration systèmes, et des technologies liées aux environnements serveurs et cloud",
      technologies: ["Projets Perso & Scolaire", "Réseau", "Cybersécurité"],
      link : "#"
    },
    {
      id: 8,
      title: "Cobian Reflector",
      year: "2024",
      description: "Mise en place de sauvegardes automatisées pour externaliser les sauvegardes internes de plusieurs serveurs",
      technologies: ["Projets Perso & Scolaire", "Windows", "Réseau"],
      link : "#"
    },
    {
      id: 9,
      title: "GLPI",
      year: "2024",
      description: "Mise en place d'un serveur GLPI avec création de sa documentation, et migration d'ancienne version à une nouvelle version",
      technologies: ["Projets Scolaire & Profesionnel", "Réseau", "Linux"],
      link : "#"
    },
    {
      id: 10,
      title: "Haute Disponibilité",
      year: "2025",
      description: "Mise en place d’un système de répartition de charge (Load Balancing) afin d’assurer un SLA de 99,99 %, notamment pour mon site portfolio et mes serveurs informatiques",
      technologies: ["Projets Pero & Scolaire", "Linux", "Réseau"],
      link : "https://docs.julieng6v.fr/books/heartbeat"
    }
  ],
  contact: {
    email: "hello@julienlebas.fr",
    phone: "+33 6 52 89 61 04",
    social: {
      instagram: "https://www.instagram.com/julienlbs_shoot/",
      linkedin: "https://www.linkedin.com/in/julien-lebas-791b22265/",
      youtube: "https://docs.julieng6v.fr/"
    }
  },
  skills: {
    technical: [
      { name: "Linux" },
      { name: "Proxmox"},
      { name: "WindowsServer"},
      { name: "Windows"},
      { name: "TCP/IP, DHCP, VLAN"},
      { name: "Active Directory"},
      { name: "ITIL"},
      { name: "OpenVPN"},
      { name: "WireGuard"},
      { name: "IPtables"},
      { name: "Apache & Nginx"},
    ],
    languages: [
      { name: "Français"},
      { name: "Anglais"},

    ]
  },
  personalInfo: {
    interests: [
      {
        title: "Drone & Photos",
        description: "Sony A7 II & DJI Mavic Mini, je réalise plusieurs projets personnels ou professionnels."
      },
      {
        title: "Sport",
        description: "Escalade, Randonnée, VTT, Paddle."
      },
      {
        title: "Voyages",
        description: "Turquie, Vietnam, Hongrie, Espagne, Etats-Unis, Egypte,"
      },
      {
        title: "hello@julienlebas.fr",
        description: "Passionné de vélos, Photos & Vidéos"
      }
    ],
    contact: {
      email: "hello@julienlebas.fr",
      phone: "+33 6 52 89 61 04",
      social: {
        instagram: "https://www.instagram.com/julienlbs_shoot/",
        linkedin: "https://www.linkedin.com/in/julien-lebas-791b22265/",
        youtube: "https://docs.julieng6v.fr/"
      }
    }
  }
}; 
